import { render } from "./SelectOMaticPlayer.vue?vue&type=template&id=764e95a4&scoped=true"
import script from "./SelectOMaticPlayer.vue?vue&type=script&lang=js"
export * from "./SelectOMaticPlayer.vue?vue&type=script&lang=js"

import "./SelectOMaticPlayer.vue?vue&type=style&index=0&id=764e95a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764e95a4"]])

export default __exports__